var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('apexchart',{ref:"chart",attrs:{"height":_vm.height,"options":_vm.options,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }